import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import Button from "src/components/Inputs/Button";

import styles from "./styles.module.scss";
import {
  useConnections,
  useCreateMessage,
} from "src/services/hooks/connections";
import FormInput from "src/components/Inputs/Formik/FormInput";
import FormSelect from "src/components/Inputs/Formik/FormSelect";

const LABEL_WIDTH = 200;

const CreateMessage = ({ connectionId, text, onSubmit }) => {
  const { t } = useTranslation();

  const { data: connections } = useConnections();

  const { mutateAsync: createMessage } = useCreateMessage();

  const submitForm = async (values) => {
    onSubmit(await createMessage(values));
  };

  return (
    <div className={styles.container}>
      <div className={styles.body}>
        <Formik
          initialValues={{
            connectionId,
            text: "",
          }}
          validationSchema={Yup.object().shape({
            connectionId: Yup.string(),
            text: Yup.string().required(),
          })}
          onSubmit={submitForm}
        >
          {({ isSubmitting, values, setFieldValue }) => (
            <Form className={styles.form}>
              <FormSelect
                horizontal
                labelWidth={LABEL_WIDTH}
                name="connectionId"
                label={t("createMessage.connectionId")}
                disabled={isSubmitting}
                className={styles.input}
                options={[
                  { id: "", label: "Connectionless" },
                  ...(connections || [])
                    .filter(({ state }) => state === "Connected")
                    .map(({ id, name: label = id }) => ({
                      id,
                      label,
                    })),
                ]}
              />
              <FormInput
                horizontal
                disabled={isSubmitting}
                labelWidth={LABEL_WIDTH}
                label={t("createMessage.message")}
                name="text"
              />

              <Button
                type="submit"
                disabled={isSubmitting}
                className={styles.button}
              >
                {isSubmitting
                  ? t("createMessage.saveLoading")
                  : t("createMessage.save")}
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CreateMessage;
